export const errorToString = (error: unknown): string =>
  error instanceof Error ? error.message : String(error);
